import { Component } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: 'tooltip.html',
  inputs: ['tooltipData']
})

export class TooltipComponent {

  tooltipData: any;

  constructor() {

  }

}


// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.ts